const passengers = {
  passengers: 'Fahrgäste',
  passengerTypes: {
    default: 'Standard',
    student: 'Schüler',
    employee: 'Mitarbeiter',
    caregiver: 'Betreuer',
  },
  headerButtons: {
    create: {
      createBtn: 'Erstellen',
      employee: 'Mitarbeiter',
      student: 'Schüler',
    },

    import: 'Importieren',
  },

  toast: {
    error: {
      badResponse: '[Passagier] fehlerhafte Serverantwort',
      create: {},
      edit: {},
    },
    success: {
      resetSuccess: 'Die E-Mail zum Zurücksetzen des Passworts wurde erfolgreich gesendet.',
      create: {
        default: '[Passagier] Erstellt',
      },
      edit: {
        default: '[Passagier] Aktualisiert',
      },
      delete: {
        default: '[Passagier] erfolgreich gelöscht',
      },
    },
    alreadyExistToast: {
      messages: {
        phone: 'Telefon wird bereits von einem anderen Fahrgast verwendet',
        email: 'E-Mail wird bereits von einem anderen Fahrgast verwendet',
      },
    },
  },

  deleteModal: {
    header: 'Fahrgast löschen',
    body: 'Sie sind dabei, {{num}} Fahrgäste zu löschen.',
  },

  create: {
    successToast: {
      message: 'Erfolg! Fahrgast erfolgreich erstellt',
    },
    errorToast: {
      message: 'Es ist ein Fehler aufgetreten. Fahrgast konnte nicht erstellt werden!',
    },
  },

  update: {
    successToast: {
      message: 'Erfolg! Fahrgast-Updates erfolgreich',
    },
    errorToast: {
      message: 'Es ist ein Fehler aufgetreten. Der Fahrgast konnte nicht aktualisiert werden!',
    },
  },

  edit: {
    tabs: {
      information: 'Allgemeine Informationen',
      notes: 'Hinweise',
      history: 'Geschichte',
      bookingHistory: 'Buchungsverlauf',
    },
    modalRemoveConfirm: {
      header: 'Warnung!',
      body: 'Möchten Sie diesen Fahrgast wirklich löschen?',
      modalRemoveConfirmBtnConfirm: 'Löschen',
    },
    activeStatus: {
      statusActive: 'Aktiv',
      statusDeactivate: 'Inaktiv',
    },
    suspend: {
      actionActivate: 'Aufheben der Sperre',
      actionDeactivate: 'Sperren',
      suspendModal: {
        popupTitleDeactivation: 'Fahrgast sperren',
        popupTitleActive: 'Grund für die Sperrung',
        popupTitleUnsuspend: 'Grund für die Aufhebung der Sperrung',
        popupSubTitleDeactivation: 'Wählen Sie den Grund für die Sperrung aus',
        popupActionActive: 'Fahrgastsperrung aufheben',
        popupActionDeactivate: 'Fahrgast sperren',
      },
    },
  },

  table: {
    filters: {
      facility: 'Einrichtung',
      type: 'Typ',
      attributes: 'Attribute',
    },
    headers: {
      name: 'Name',
      type: 'Typ',
      email: 'E-Mail',
      created: 'Erstellungsdatum',
      id: 'Ausweis',
      profile: 'Profil',
      supplier: 'Anbieter',
      phone: 'Telefon',
      createdBy: 'Erstellt von',
      baseAddress: 'Privatadresse',
      occupationAddress: 'Büroadresse',
      attributes: 'Attribute',
    },
    passengersGettExtraHeaders: {
      home: 'Privat',
      home2: 'Privat 2',
      work: 'Arbeit',
      site: 'Bereich',
    },
    empty: 'Leer',
    actions: {
      delete: 'Löschen',
      export: 'Exportieren',
    },
    toolTip: {
      noPermission: 'Aktion nicht zulässig: Berechtigung erforderlich',
    },
  },
  import: {
    title: 'Fahrgäste hochladen',
  },

  forms: {
    header: {
      createPassenger: {
        title: 'Erstellen',
      },

      updatePassenger: {
        title: 'Aktualisieren',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
    },

    information: {
      profile: {
        header: 'Profil',
        fields: {
          profile: 'Profil',
        },
      },
      supplier: {
        header: 'Anbieter',
        fields: {
          label: 'Bevorzugter Anbieter',
        },
      },
      attributes: {
        header: 'Eigenschaften',
        fields: {
          label: 'Eigenschaften',
        },
      },
      paymentTypes: {
        header: 'Bezahlarten',
        fields: {
          membership: 'Mitgliedschaft',
        },
        actions: {
          save: 'Speichern',
        },
      },
      details: {
        header: 'Persönliche Daten',
        fields: {
          firstName: 'Vorname',
          lastName: 'Nachname',
          email: 'E-Mail',
          phone: 'Telefon',
          ada: 'Ada',
          additionalPhone: 'Zusätzliches Telefon',
          code: 'Code',
        },
      },
      address: {
        header: 'Fahrgastadresse',
        sharedValues: {
          manual: 'Manuelle Adresse',
        },
        fields: {
          homeAddress: {
            label: 'Privatadresse',
          },
          homeAddress2: {
            label: 'Privatadresse 2',
          },
          officeAddress: {
            label: 'Büroadresse',
          },
          workAddress: {
            label: 'Arbeitsadresse',
          },
        },
      },
      actions: {
        header: 'Aktionen',
        buttons: {
          delete: 'Löschen',
          resetPassword: 'Passwort zurücksetzen',
        },
      },
      health: {
        header: 'Gesundheitsinformationen',
        fields: {
          certificationDate: 'Zertifizierungsdatum',
          expirationDate: 'Verfallsdatum',
          disabilityAidTools: 'Hilfsmittel für Behinderte',
        },
      },
      caregiverInfo: {
        header: 'Informationen zur Pflegekraft',
        fields: {
          caregiverFirstName: 'Vorname',
          caregiverLastName: 'Nachname',
          caregiverEmail: 'E-Mail',
          caregiverPhone: 'Telefon',
        },
      },
      jobClusters: {
        header: 'Reservierungscluster',
        fields: {
          limitedMobility: 'Eingeschränkte Mobilität',
        },
        information: {
          limitedMobility: 'The system will ignore "Maximal Distance" and select the nearest possible pickup/dropoff point to the passenger\'s address',
        }
      },
    },
    jobHistory: {
      header: 'Buchungsverlauf',
      popupInfo: {
        date: 'Gewünschte Abholzeit: {{time}}',
        header: 'Buchungsinformationen',
        from: 'Von:',
        to: 'Nach:',
      },
    },

    validations: {
      firstName: 'Vorname ist erforderlich',
      lastName: 'Nachname ist erforderlich',
      profiles: 'Profile sind erforderlich',
      email: {
        required: 'E-Mail ist erforderlich',
        email: 'Ungültige E-Mail-Adresse',
      },
      unit: {
        required: 'Bereich ist erforderlich',
      },
    },
  },

  statuses: {
    onATrip: 'Fahrgäste auf einer Fahrt',
    completed: 'Fahrgäste haben Fahrten abgeschlossen',
    created: 'Erstellte Fahrgäste (ab {{hourFrom}})',
  },

  totalPassengers: 'Fahrgäste insgesamt',
};

export default passengers;
